<template>
  <div class="config">
    <div class="imagess">
      <!-- <div class="logo">
        <img src="../assets/logo.png" alt />
      </div>
      <div class="nav_title">
        <img src="../assets/big_title.png" alt />
      </div> -->
      <div class="nav_txt">您已申报成功！</div>
      <!-- <div class="line"></div> -->
      <div class="nav_msg">感谢您对本次评选的积极参与。本届评选具体流程详见申报首页。</div>
      <div class="tit">{{num}}S 后返回首页</div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      num: 10,
      tirm: null,
    };
  },
  methods: {
    goto() {
      this.tirm = setInterval((_) => {
        this.num--;
        if (this.num <= 0) {
          clearInterval(this.tirm);
          this.$router.push({
            path: "/",
          });
        }
      }, 1000);
    },
  },
  mounted() {
    this.goto();
  },
};
</script>

<style lang="scss">
.config {
  background-color: #000;
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  .imagess {
    position: relative;
    width: 100%;
    height: 100%;
    background: url("../assets/1920_y2025.png") no-repeat;
    background-size: 100%;
    // height: 34.7rem;
    overflow: hidden;

    .logo {
      width: 1.45rem;
      height: 0.7rem;
      margin: 1.11rem auto 0.56rem;
      transform: translateX(-7.75rem);
      img {
        width: 100%;
        height: auto;
      }
    }

    .nav_title {
      width: 7.63rem;
      height: 2.68rem;
      margin: 0 auto;
      img {
        width: 100%;
        height: auto;
      }
    }

    .nav_txt {
      height: 0.39rem;
      font-size: 0.42rem;
      font-weight: 500;
      color: #F1CEA8;
      line-height: 0.33rem;
      text-shadow: 0rem 0rem 0rem rgba(13, 4, 9, 0.33);
      margin: 5.9rem auto 0.2rem;
    }

    .line {
      width: 9.06rem;
      height: 0.02rem;
      background: #EECCA5;
      margin: 0 auto;
    }

    .nav_msg {
      height: 0.23rem;
      font-size: 0.24rem;
      font-weight: 500;
      color: #F1CEA8;
      line-height: 0.56rem;
      margin: 0.2rem auto 0.17rem;
    }

    .tit {
      height: 0.22rem;
      font-size: 0.24rem;
      font-weight: 400;
      color: #F1CEA8;
      line-height: 0.56rem;
      opacity: 0.8;
      margin: 0 auto;
    }
  }
}
</style>